import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Block from '../components/Block';
import Heading from '../components/Heading';
import Grid from '@mui/material/Grid/Grid';

import { ReactComponent as FortesLogo } from '../assets/fortes-interactive-logo.svg';
//import { ReactComponent as DieboldLogo } from '../assets/diebold-nixdorf-logo.svg';
//import { ReactComponent as SpandexLogo } from '../../public/thumb-spandex_logo_rgb_mono_dark.png';
import misa from '../assets/misa.png';
//import michaela from '../assets/michaela.png';
import spandex_logo from '../assets/thumb-spandex_logo_rgb_mono_dark.png';
import Chip from '../components/Chip';
import { Box, Button } from '@mui/material';
import HeadingSmall from '../components/HeadingSmall';

interface IState {
}

interface IProps extends WithTranslation {
}

class Contacts extends React.Component<IProps, IState, WithTranslation> {

	constructor(props: IProps){		
		super(props);				
		this.state = {};
	}

    openFortes(lang: string) {
        if(lang === 'cs') window.open("https://www.fortesinteractive.com/cs")
        else window.open("https://www.fortesinteractive.com/")
    }

    openSpandexLotus() {
        window.open("https://shop.spandex.com/cs_CZ/materialy-pro-graficky-prumysl-a-signmaking/laminace/specialni-laminacni-folie/healthcare-film/lotus-foil/p/FVA")
    }

    openSpandexCZ() {
        window.open("https://shop.spandex.com/cs_CZ/")
    }

    openSpandexSK() {
        window.open("https://shop.spandex.com/sk_SK/")
    }    

	render() {	
		const t = this.props.t;
        const ns = 'main';
        const contactSx = { display: 'flex', rowGap: '8px', margin: 'auto', justifyContent: 'flex-end', flexDirection: 'column' };

		return <Block color='primary.main' fullHeight={true} rounded sx={{ rowGap: { xs: '20px', lg: '80px', xl: '100px'}, justifyContent: 'flex-start'}}>

            <Box sx={{ mt: { lg: 0, xl: '60px' }}}>
                <Heading lightBg={false}>
                    {t('contacts', {ns})}
                </Heading>
            </Box>

            <Grid container spacing={4} sx={{ flexGrow: 0, height: 'fit-content', p: { xs: '10px', sm: '10px', md: 0 } }}>
                <Grid item container xs={12} lg={6} columnSpacing={1} rowSpacing={4}>
                    <Grid item sm={2.5}>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Chip label={t('manufacturer', {ns})} />
                            </Grid>
                            <Grid item xs={12}>
                                <Chip label='FORTES Interactive' />
                            </Grid>
                            <Grid display="flex" justifyContent="center" alignItems="center" width="100%">
                                <Button onClick={() => this.openFortes(this.props.i18n.language)}>
                                    <FortesLogo style={{ marginTop: '30px', alignSelf: 'center', maxWidth: "90px" }}/>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={3.5} className='contact-image'>
                        <img src={misa} alt='Michaela Fanglová' />
                    </Grid>

                    <Grid item xs={12} sm={4} md={4} sx={contactSx}>
                        <Chip label='Michaela Fanglová' size='medium' />
                        <Chip label='+420 723 664 861' size='medium' />
                        <Chip label='michaela@lotusfoil.com' size='medium' sx={{ fontSize: '10px' }} />
                    </Grid>
                </Grid>

                <Grid item container xs={12} lg={5.5} columnSpacing={1} rowSpacing={4}>
                    {/* <Grid item sm ={2}/> */}
                    <Grid item sm={3}>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Chip label={t('distributor', {ns})} />
                            </Grid>
                            <Grid item xs={12}>
                                <Chip label='Spandex' />
                            </Grid>
                            <Button onClick={this.openSpandexLotus}>
                                <img src={spandex_logo} alt="spandex_logo" style={{ maxHeight: "80px", maxWidth: "190px", }} />
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={9} sx={{...contactSx, flexDirection: "row"}} >
                        {/* <Chip label='Michaela Janková' size='medium' />
                        <Chip label='michaela.jankova@dieboldnixdorf.com' size='medium' sx={{ fontSize: '10px' }} /> */}
                        <Grid sm={5.5} sx={contactSx}>
                            <HeadingSmall lightBg={false}>{t("czech-republic", {ns})}</HeadingSmall>
                            <Chip 
                                label='+420 286 006 455'
                                size='medium'
                                
                            />
                        
                            <Chip 
                                label='+420 545 422 355'
                                size='medium'
                           
                            />
                            <Chip 
                                label='objednavky.cz@spandex.com'
                                size='medium'
                                onClick={this.openSpandexCZ}
                                sx={{fontSize: "10px"}}
                            />
                            <Box sx={{height: "30px"}}/>
                    
                        </Grid>
                        <Grid sm={0.5}/>
                        <Grid sm={5.5} sx={contactSx}>
                            <HeadingSmall lightBg={false}>{t("slovakia", {ns})}</HeadingSmall>
                            <Chip 
                                label='+421 2 3333 5555'
                                size='medium'
                            />
                            <Chip 
                                label='objednavky.sk@spandex.com'
                                size='medium'
                                onClick={this.openSpandexSK}
                                sx={{fontSize: "10px"}}
                            />
                            <Box sx={{height: "70px"}}/>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Block>;
	}
}

export default withTranslation()(Contacts);